import { Box, Text } from '@rbilabs/universal-components';

import { InnerLayout, LayoutContainer } from 'components/layout/styled';
import { primitive } from 'styles/constants/primitives';

export const Wrapper = Box.withConfig({
  background: primitive.$white,
});

export const ProductOrderReviewWrapper = Box.withConfig({
  flex: 1,
  background: Styles.color.white,
  margin: 0,
  padding: 0,
});

export const Container = Box.withConfig({
  width: 'full',
  height: 'auto',
  paddingTop: '12px',
  alignItems: 'center',
  display: 'flex',
  background: primitive.$white,
});

export const ProductTitle = Text.withConfig({
  accessible: true,
  focusable: true,
  variant: 'headerTwo',
  margin: 0,
  fontSize: '2xl',
  lineHeight: 'md',
  paddingBottom: '12px',
  paddingX: '$8',
  textAlign: 'center',
});

export const ProductOrderReviewContainer = Box.withConfig({
  backgroundColor: primitive.bk.$mayoEggWhite,
  flex: 1,
  margin: 0,
  padding: 0,
  marginTop: {
    base: '$4',
    md: '$8',
  },
});

export const ProductReviewLayoutContainer = LayoutContainer.withConfig({
  marginY: 0,
  paddingY: 0,
});

export const ProductOrderReviewInnerLayout = InnerLayout.withConfig({
  marginY: 0,
  paddingY: 0,
});
